export enum ActionConstants {
	SET_CURRENT_SCREEN_STATE = 'set_current_screen_state',
	OPEN_SUCCESS = 'screen_success_open',
	CLOSE_SUCCESS = 'screen_success_close',
}
